import { render, staticRenderFns } from "./TransferChat.vue?vue&type=template&id=547fd873&"
import script from "./TransferChat.vue?vue&type=script&lang=js&"
export * from "./TransferChat.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports